import FeaturedIcon from 'components/FeaturedIcon';
import React, { FC } from 'react';
import styled from 'styled-components';
import SearchIcon from '../icons/Search';
import { DefaultLoader } from '../Loader';
import ListFoot from './Foot';

const EmptyContainer = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--gray-900);
`;

const Container = styled.div`
  position: relative;
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  overflow-x: hidden;
  & > * {
    white-space: nowrap;
  }
`;

type Props = {
  columnNumber: number;
  placeCheckbox?: boolean;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const DivWithProps: FC<Props> = ({ columnNumber, placeCheckbox, ...props }) => {
  return <div {...props} />;
};
const Table = styled(DivWithProps)`
  display: grid;
  overflow-x: auto;
  grid-template-columns: ${({ columnNumber }) =>
    columnNumber === 1
      ? '1fr'
      : `${
          columnNumber > 2 ? `repeat(${columnNumber - 2}, auto) ` : ''
        }1fr auto`};
  font-size: 0.9rem;
  width: 100%;
  font-weight: 400;
  color: var(--gray-500);
  stroke: var(--gray-500);
  border-collapse: collapse;

  // Alternate bg color
  ${({ columnNumber }) => {
    let s = '';
    for (let i = 1; i <= columnNumber; i++) {
      s += `&>div:nth-child(${2 * columnNumber}n+${i + columnNumber}),`;
    }
    return s.slice(0, -1);
  }} {
    background: var(--gray-50);
  }

  /* DISABLED */
  /* ${({ placeCheckbox, columnNumber }) =>
    !placeCheckbox
      ? ''
      : // First column
        `& > *:nth-child(${columnNumber}n +1){ \
			padding-right: 0;\
		}` +
        // Second column
        `& > *:nth-child(${columnNumber}n +2){\
			padding-left: .75rem;\
		}`} */
`;

const ListLoadingContainer = styled.div`
  position: absolute;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: grid;
  place-items: center;
`;

type ContextType = {
  activeColumns: Record<string, boolean>;
};
export const ListContext = React.createContext({} as ContextType);
const { Provider } = ListContext;

type ListProps = Props & {
  isEmpty: boolean;
  emptyText: string;
  pages?: number;
  page: number;
  setPage: (page: number) => void;
  loading?: boolean;
  activeColumns: Record<string, boolean>;
};
const List: FC<ListProps> = ({
  columnNumber,
  isEmpty,
  emptyText,
  placeCheckbox,
  children,
  pages,
  page,
  setPage,
  loading,
  activeColumns,
}) => {
  return isEmpty ? (
    <EmptyContainer>
      <FeaturedIcon icon={<SearchIcon />} />
      <p>{emptyText}</p>
      {loading && (
        <div style={{ marginTop: '2rem' }}>
          <DefaultLoader />
        </div>
      )}
    </EmptyContainer>
  ) : (
    <Provider value={{ activeColumns }}>
      <Container>
        {loading && (
          <ListLoadingContainer>
            <DefaultLoader size={1.5} />
          </ListLoadingContainer>
        )}
        <Table columnNumber={columnNumber} placeCheckbox={placeCheckbox}>
          {children}
        </Table>
        <ListFoot pages={pages} page={page} setPage={setPage} />
      </Container>
    </Provider>
  );
};

export default List;
